import React from "react";
import PropTypes from "prop-types";
import ModalWrapper from "../components/modal_wrapper/modal_wrapper";
import {
  innerStyle,
  modalInnerOverflowStyle,
} from "./modal_contain.module.scss";

function ModalContain({
  children,
  isModalActive,
  callbackToCloseModal,
  modalTitle,
}) {
  return (
    <ModalWrapper
      {...{ children, isModalActive, callbackToCloseModal, modalTitle }}
    >
      <div className={modalInnerOverflowStyle}>
        <div className={innerStyle}>{children}</div>
      </div>
    </ModalWrapper>
  );
}

ModalContain.propTypes = {
  children: PropTypes.node,
  modalTitle: PropTypes.string,
  isModalActive: PropTypes.bool,
  callbackToCloseModal: PropTypes.func,
};

ModalContain.defaultProps = {
  children: null,
  isModalActive: false,
  modalTitle: null,
  callbackToCloseModal: null,
};

export default ModalContain;
